import React, { useState } from "react";

export default function ConfirmModal({ title, message, confirmLabel = "Confirm", danger, onConfirm, onClose }) {
	const [busy, setBusy] = useState(false);
	const confirm = async () => {
		setBusy(true);
		await onConfirm();
		setBusy(false);
	};
	return (
		<div className="modal d-block" style={{ background: "rgba(0,0,0,0.4)" }} onClick={onClose}>
			<div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
				<div className="modal-content p-4">
					<h5 className="fw-bold mb-2">{title}</h5>
					{message ? <p className="text-muted mb-4">{message}</p> : null}
					<div className="d-flex gap-2 justify-content-end">
						<button className="btn-outline" onClick={onClose} disabled={busy}>
							Cancel
						</button>
						<button className={danger ? "btn btn-danger" : "btn-accent-solid"} onClick={confirm} disabled={busy}>
							{busy ? "Working..." : confirmLabel}
						</button>
					</div>
				</div>
			</div>
		</div>
	);
}
